import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=22024f5e&scoped=true"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"
import style0 from "./InputField.vue?vue&type=style&index=0&id=22024f5e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22024f5e",
  null
  
)

export default component.exports